const typography = {
  fontSize: 13,
}

export default typography
